(function () {
  try {
    if (window.__tlGiftMsgLoaded) return;
    window.__tlGiftMsgLoaded = true;

    // Edit texts here. Placeholders: {{amount}} remaining amount, {{count}} number of gifts to choose
    var TEXT = {
      next_single: 'Add {{amount}} more to get this FREE gift:',
      next_choose: 'Add {{amount}} more to choose {{count}} FREE gift(s) from:',
      next_reward: 'Add {{amount}} more to unlock:',
      unlocked_title: '🎉 You have unlocked:',
      unlocked_hint_manual: 'Click "Select gifts" below to claim your gift.'
    };
    var SHOW_UNLOCKED = true; // show the "unlocked" box
    var SHOW_NEXT = true; // show the "next gift" box
    var ONLY_GIFT = false; // true: ignore discount / free shipping milestones

    var WIDGET = '.tl__cart-goal__container__drawer';
    var DESC = '.tl__cart-goal__reward-description__drawer';
    var MSG_CLASS = 'tl-gift-msg';

    var CSS = [
      '.tl-gift-msg { width: 100%; margin: 8px 0; font-size: 13px; line-height: 1.4; color: inherit; }',
      '.tl-gift-msg__box { padding: 8px 10px; border-radius: 6px; margin-bottom: 6px; }',
      '.tl-gift-msg__box:last-child { margin-bottom: 0; }',
      '.tl-gift-msg__box--next { background: #f6f6f7; border: 1px dashed #c9cccf; }',
      '.tl-gift-msg__box--unlocked { background: #e7f6ec; border: 1px solid #9fd6b0; }',
      '.tl-gift-msg__title { margin: 0 0 4px; font-weight: 600; }',
      '.tl-gift-msg__hint { margin: 4px 0 0; font-size: 12px; opacity: .8; }',
      '.tl-gift-msg__list { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 6px; }',
      '.tl-gift-msg__item { display: flex; align-items: center; gap: 8px; margin: 0; }',
      '.tl-gift-msg__item img { width: 36px; height: 36px; object-fit: cover; border-radius: 4px; flex-shrink: 0; }'
    ].join('\n');

    function injectStyle() {
      try {
        if (document.getElementById('tl-gift-msg-style')) return;
        var style = document.createElement('style');
        style.id = 'tl-gift-msg-style';
        style.textContent = CSS;
        (document.head || document.documentElement).appendChild(style);
      } catch (e) {
        console.warn('[tl-gift-msg] style error', e);
      }
    }

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function imgUrl(v) {
      try {
        var src = (v.featured_image && v.featured_image.src) || v.featured_image || '';
        if (!src) return '';
        var u = new URL(src, window.location.origin);
        if (u.hostname === 'cdn.shopify.com' && !/\.(svg|gif)$/i.test(u.pathname)) u.searchParams.set('width', '100');
        return u.toString();
      } catch (e) {
        return '';
      }
    }

    function formatRemaining(app, milestone) {
      var remaining = Math.max(milestone.cart_value - app.cartTotal, 0);
      if (app.isQuantityBased) return app.formatQuantity(remaining);
      return app.formatMoney(100 * remaining, app.currencyFormat, app.currencyDisplay);
    }

    // Gift variants loaded by the app for a milestone (empty if not loaded / out of stock)
    function getGiftVariants(app, milestoneIndex) {
      try {
        var listIndex = app.milestoneIndexInGiftsList && app.milestoneIndexInGiftsList.get(milestoneIndex);
        var variants = (listIndex != null && app.gifts && app.gifts[listIndex]) || [];
        return variants.filter(function (v) { return v && v.available !== false; });
      } catch (e) {
        return [];
      }
    }

    function giftListHTML(variants) {
      return '<ul class="tl-gift-msg__list">' + variants.map(function (v) {
        var src = imgUrl(v);
        var qty = v.specificQuantity > 1 ? ' × ' + esc(v.specificQuantity) : '';
        return '<li class="tl-gift-msg__item">' +
          (src ? '<img src="' + esc(src) + '" alt="" loading="lazy">' : '') +
          '<span><strong>' + esc(v.name) + '</strong>' + qty + '</span></li>';
      }).join('') + '</ul>';
    }

    function rewardName(app, milestone, index) {
      if (milestone.reward_type === 'gift') {
        var variants = getGiftVariants(app, index);
        if (variants.length) return variants.map(function (v) { return v.name; }).join(', ');
      }
      // milestone.title is merchant content (may contain HTML) - strip tags
      var tmp = document.createElement('div');
      tmp.innerHTML = milestone.title || '';
      return tmp.textContent || '';
    }

    function buildHTML(app) {
      var milestones = app.milestones;
      var cartGoal = app.cartGoal || {};
      if (!Array.isArray(milestones) || !milestones.length || typeof app.cartTotal !== 'number') return '';

      var isRelevant = function (m) { return !ONLY_GIFT || m.reward_type === 'gift'; };
      var stackLatest = cartGoal.reward_stack === 'lastest';
      var unlocked = [];
      var next = null;
      var nextIndex = -1;
      var latestPassed = -1;

      milestones.forEach(function (m, i) {
        if (app.cartTotal >= m.cart_value) latestPassed = i;
        else if (!next && isRelevant(m)) { next = m; nextIndex = i; }
      });
      milestones.forEach(function (m, i) {
        if (i > latestPassed || !isRelevant(m)) return;
        // "Only latest milestone" stack: only the highest reached reward is granted
        if (stackLatest && i !== latestPassed) return;
        unlocked.push({ m: m, i: i });
      });

      var html = '';

      if (SHOW_UNLOCKED && unlocked.length) {
        var hasManualGift = !cartGoal.auto_add_reward && unlocked.some(function (u) { return u.m.reward_type === 'gift'; });
        html += '<div class="tl-gift-msg__box tl-gift-msg__box--unlocked">' +
          '<p class="tl-gift-msg__title">' + esc(TEXT.unlocked_title) + '</p>' +
          '<ul class="tl-gift-msg__list">' + unlocked.map(function (u) {
            return '<li class="tl-gift-msg__item"><span>✅ <strong>' + esc(rewardName(app, u.m, u.i)) + '</strong></span></li>';
          }).join('') + '</ul>' +
          (hasManualGift ? '<p class="tl-gift-msg__hint">' + esc(TEXT.unlocked_hint_manual) + '</p>' : '') +
          '</div>';
      }

      if (SHOW_NEXT && next) {
        var amount = formatRemaining(app, next);
        var body;
        if (next.reward_type === 'gift') {
          var variants = getGiftVariants(app, nextIndex);
          var count = Number(next.reward_value) || 1;
          if (variants.length) {
            var tpl = variants.length > count ? TEXT.next_choose : TEXT.next_single;
            body = '<p class="tl-gift-msg__title">' + tpl.replace('{{amount}}', amount).replace('{{count}}', esc(count)) + '</p>' + giftListHTML(variants);
          }
        }
        if (!body) {
          body = '<p class="tl-gift-msg__title">' + TEXT.next_reward.replace('{{amount}}', amount) + '</p>' +
            '<p class="tl-gift-msg__item"><strong>' + esc(rewardName(app, next, nextIndex)) + '</strong></p>';
        }
        html += '<div class="tl-gift-msg__box tl-gift-msg__box--next">' + body + '</div>';
      }

      return html;
    }

    function render() {
      try {
        var app = window.tlCartGoalEmbed;
        if (!app) return;
        var widgets = document.querySelectorAll(WIDGET);
        if (!widgets.length) return;
        var html = buildHTML(app);

        widgets.forEach(function (widget) {
          try {
            var box = widget.querySelector('.' + MSG_CLASS);
            if (!html) {
              if (box) box.remove();
              return;
            }
            if (!box) {
              box = document.createElement('div');
              box.className = MSG_CLASS;
              var desc = widget.querySelector(DESC);
              if (desc) desc.insertAdjacentElement('afterend', box);
              else widget.prepend(box);
            }
            // Only touch the DOM when content changes (prevents observer loops)
            if (box.__tlHtml !== html) {
              box.innerHTML = html;
              box.__tlHtml = html;
            }
          } catch (e) {
            console.warn('[tl-gift-msg] render widget error', e);
          }
        });
      } catch (e) {
        console.warn('[tl-gift-msg] render error', e);
      }
    }

    var timer = null;
    function scheduleRender(delay) {
      try {
        clearTimeout(timer);
        timer = setTimeout(render, delay || 80);
      } catch (e) {}
    }

    function isOwnNode(node) {
      return node && node.nodeType === 1 && (node.classList.contains(MSG_CLASS) || !!node.closest('.' + MSG_CLASS));
    }

    function isRelevantMutation(m) {
      var target = m.target && m.target.nodeType === 1 ? m.target : m.target && m.target.parentElement;
      if (!target || isOwnNode(target)) return false;
      if (target.closest(WIDGET)) return true;
      if (m.type !== 'childList') return false;
      for (var i = 0; i < m.addedNodes.length; i++) {
        var n = m.addedNodes[i];
        if (n.nodeType === 1 && !isOwnNode(n) && (n.matches(WIDGET) || n.querySelector(WIDGET))) return true;
      }
      return false;
    }

    function start() {
      injectStyle();

      try {
        new MutationObserver(function (mutations) {
          try {
            for (var i = 0; i < mutations.length; i++) {
              if (isRelevantMutation(mutations[i])) {
                scheduleRender();
                return;
              }
            }
          } catch (e) {}
        }).observe(document.body, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['class', 'style']
        });
      } catch (e) {
        console.warn('[tl-gift-msg] observer error', e);
      }

      // Fallback: cart total is recalculated async after cart changes
      ['TLCARTGOAL:add', 'TLCARTGOAL:change', 'TLCARTGOAL:update', 'TLCARTGOAL:clear'].forEach(function (name) {
        window.addEventListener(name, function () {
          scheduleRender(400);
          setTimeout(render, 1500);
        });
      });

      render();
    }

    if (document.body) start();
    else document.addEventListener('DOMContentLoaded', start);
  } catch (e) {
    console.warn('[tl-gift-msg] init error', e);
  }
})();
